import pick from 'lodash/pick'
import isEqualWith from 'lodash/isEqualWith'
import isDate from 'date-fns/is_date'
import isSameDay from 'date-fns/is_same_day'

export default function propsChanged(obj1, obj2, props) {
  if (!props) return false
  const props1 = pick(obj1, props)
  const props2 = pick(obj2, props)

  return !isEqualWith(props1, props2, (a, b) => {
    if (isDate(a) && isDate(b)) {
      return isSameDay(a, b)
    }
  })
}



// WEBPACK FOOTER //
// ./client/utils/propsChanged.js